import { PREMIUM_FEATURES } from "./flatRateBilling";

export const PLAN_CAPABILITY_UPGRADE_MESSAGES = {
    [PREMIUM_FEATURES.UNLIMITED_ENTITIES]:
        "Upgrade to Plus to create additional entities",
    [PREMIUM_FEATURES.CLASSES]: "Upgrade to Plus to use classes",
    [PREMIUM_FEATURES.ACCRUAL_LEDGER]:
        "This workspace's plan does not include the accrual ledger. Use the cash ledger if appropriate, or upgrade to a plan that includes accrual accounting.",
    [PREMIUM_FEATURES.DOCUMENT_CLASSIFICATION]:
        "Upgrade to Plus to use document classification",
    [PREMIUM_FEATURES.IMPORTER]: "Upgrade to Basic to use importer",
    [PREMIUM_FEATURES.RECONCILIATION]: "Upgrade to Basic to use reconciliation",
    [PREMIUM_FEATURES.GUSTO]: "Upgrade to Basic to connect Gusto",
    [PREMIUM_FEATURES.PLAID_STATEMENTS]:
        "Upgrade to Basic to sync Plaid statements",
    [PREMIUM_FEATURES.INVOICE_PAYMENT_COLLECTION]:
        "Upgrade to Basic to collect invoice payments",
    [PREMIUM_FEATURES.AP_RECONCILIATION]:
        "Upgrade to Plus to use AP reconciliation",
    [PREMIUM_FEATURES.CONSOLIDATION]:
        "Upgrade to Advanced to use consolidation",
    [PREMIUM_FEATURES.SCHEDULES]: "Upgrade to Advanced to schedule invoices",
    [PREMIUM_FEATURES.FIXED_ASSETS]:
        "Upgrade to Advanced to track fixed assets",
    [PREMIUM_FEATURES.INVOICES]: "Upgrade to Basic to use invoicing",
    [PREMIUM_FEATURES.INTEGRATIONS]: "Upgrade to Basic to connect integrations",
    [PREMIUM_FEATURES.AGENT_ACCESS]:
        "Upgrade to Basic to use MCP and the CLI. Workspaces managed by your organization are included.",
} as const satisfies Record<PREMIUM_FEATURES, string>;
